import { axiosInstance, requestConfig } from 'network/apis';

import { URL_HUB } from 'utils/constants';

export const callShopNotificationInfo = async (notificationId) => {
    return await axiosInstance(requestConfig('get', URL_HUB, `/notification/${notificationId}`));
};
